var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12848 9.16683L15.5768 18.9791M34.1667 9.46198L24.5333 18.9791M6.12848 30.8335C6.71609 31.3521 7.48796 31.6668 8.33333 31.6668H31.6667C32.6622 31.6668 33.5559 31.2304 34.1667 30.5383M6.12848 30.8335C5.43646 30.2227 5 29.3291 5 28.3335V11.6668C5 9.82588 6.49238 8.3335 8.33333 8.3335H31.6667C33.5076 8.3335 35 9.82588 35 11.6668V28.3335C35 29.1789 34.6853 29.9507 34.1667 30.5383M6.12848 30.8335L15.5768 18.9791M15.5768 18.9791L17.7257 21.2107C19.0064 22.406 20.9938 22.406 22.2745 21.2107L24.5333 18.9791M24.5333 18.9791L34.1667 30.5383",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail1);
export default __webpack_public_path__ + "static/media/mail-1.889b1df87ba80d4844b1765a893bcd0b.svg";
export { ForwardRef as ReactComponent };